import { User, SignOut, Bell, DownloadSimple, CaretRight, ShieldCheck } from '@phosphor-icons/react';

/**
 * Account tab — exposes profile, settings, install and logout actions.
 * Designed for the mobile bottom-tab navigation but works on any width.
 */
export default function AccountTab({ user, isInstructor, onOpenNotifications, onOpenInstall, onLogout }) {
    return (
        <div className="space-y-4 animate-fade-in-up max-w-md mx-auto" data-testid="account-tab">
            {/* Profile card */}
            <div className="bg-[#2D3748] border border-[#4A5568] rounded-2xl p-5 flex items-center gap-4">
                <div className="w-14 h-14 rounded-full bg-[#D4A537]/15 border border-[#D4A537]/40 flex items-center justify-center text-[#D4A537] text-xl font-bold flex-shrink-0" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {(user?.name || '?').trim().slice(0, 1).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                    <div className="text-base font-semibold text-white truncate" style={{ fontFamily: 'Outfit, sans-serif' }}>
                        {user?.name || 'Onbekend'}
                    </div>
                    <div className="text-xs text-gray-400 truncate">{user?.email}</div>
                    <div className="inline-flex items-center gap-1 mt-1.5 text-[10px] uppercase tracking-widest bg-[#D4A537]/15 text-[#D4A537] border border-[#D4A537]/40 rounded-full px-1.5 py-0.5">
                        <ShieldCheck size={10} weight="fill" />
                        {isInstructor ? 'Instructeur' : 'Leerling'}
                    </div>
                </div>
            </div>

            {/* Settings list */}
            <div className="bg-[#2D3748] border border-[#4A5568] rounded-2xl divide-y divide-[#4A5568]/60 overflow-hidden">
                <Row
                    icon={<Bell size={20} weight="fill" className="text-[#D4A537]" />}
                    title="Meldingen"
                    subtitle="Beheer push-meldingen en testen"
                    onClick={onOpenNotifications}
                    testId="account-row-notifications"
                />
                <Row
                    icon={<DownloadSimple size={20} weight="bold" className="text-[#D4A537]" />}
                    title="App installeren"
                    subtitle="Plaats op je startscherm"
                    onClick={onOpenInstall}
                    testId="account-row-install"
                />
            </div>

            {/* Logout */}
            <button
                onClick={onLogout}
                className="w-full bg-[#2D3748] hover:bg-[#3D4A5C] border border-[#4A5568] hover:border-red-400/40 rounded-2xl p-4 flex items-center gap-3 transition-colors text-left active:scale-[0.99]"
                data-testid="account-logout-button"
            >
                <div className="w-10 h-10 rounded-full bg-red-500/15 border border-red-400/40 flex items-center justify-center flex-shrink-0">
                    <SignOut size={18} weight="bold" className="text-red-300" />
                </div>
                <div className="flex-1">
                    <div className="text-sm font-semibold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>Uitloggen</div>
                    <div className="text-xs text-gray-400 mt-0.5">Sluit je sessie af op dit toestel</div>
                </div>
                <CaretRight size={14} className="text-gray-500" />
            </button>

            <div className="text-center text-[10px] text-gray-600 pt-2 pb-6 tracking-widest">
                RIJSCHOOL AUTOPILOT
            </div>
        </div>
    );
}

function Row({ icon, title, subtitle, onClick, testId }) {
    return (
        <button
            onClick={onClick}
            className="w-full flex items-center gap-3 px-4 py-3.5 hover:bg-[#3D4A5C]/40 transition-colors text-left"
            data-testid={testId}
        >
            <div className="w-9 h-9 rounded-full bg-[#1A202C] border border-[#4A5568] flex items-center justify-center flex-shrink-0">
                {icon}
            </div>
            <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>{title}</div>
                <div className="text-xs text-gray-400 truncate mt-0.5">{subtitle}</div>
            </div>
            <CaretRight size={14} className="text-gray-500 flex-shrink-0" />
        </button>
    );
}
